import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography/Typography"
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton/IconButton"
import Visibility from "react-icons/lib/md/visibility"
import VisibilityOff from "react-icons/lib/md/visibility-off"
import { translate } from "react-i18next"
import flow from "lodash/flow"
import HTMLReactParser from "html-react-parser"

import styles from "./styles"

export class AppicalPasswordField extends React.Component {
    state = {
        showPassword: false,
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }))
    };

    render() {
        const {
            t, classes, input, label, meta, inputRef, className, hasLabel,
        } = this.props

        const { showPassword } = this.state
        const companyName = process.env.REACT_APP_COMPANY_NAME

        const classNames = [classes.textField, className]
        if (meta.error) {
            classNames.push(classes.error)
        } else if (meta.active) {
            classNames.push(classes.active)
        }
        return (
            <React.Fragment>
                {hasLabel && <Typography className={classes.label} variant="caption" color="inherit">{label}</Typography>}
                <div className={`${classes.textfieldWrapper} ${meta.error ? classes.hasError : ""}`}>
                    <input
                        {...input}
                        placeholder={!hasLabel ? label : t("main:password")}
                        type={showPassword ? "text" : "password"}
                        className={classNames.join(" ")}
                        aria-label={label}
                        ref={inputRef}
                        data-lpignore="true"
                        autoComplete="off"
                    />
                    <IconButton
                        className={classes.inputIcon}
                        onClick={this.handleClickShowPassword}
                        aria-label={t("main:show_password")}
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility /> }
                    </IconButton>
                    {meta.error && (
                        <div className={classes.errorContainer}>
                            <Typography
                                variant="caption"
                                color="inherit"
                            >
                                {HTMLReactParser(t(meta.error))}
                            </Typography>
                        </div>
                    )}
                </div>
            </React.Fragment>
        )
    }
}

AppicalPasswordField.propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
        active: PropTypes.bool,
    }),
    className: PropTypes.string,
    hasLabel: PropTypes.bool,
}

AppicalPasswordField.defaultProps = {
    meta: {
        touched: false,
        error: null,
        active: false,
    },
    className: "password",
    hasLabel: false,
}

export default flow([
    withStyles(styles),
    translate(),
])(AppicalPasswordField)
